import Paper from "@mui/material/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@mui/material/Typography";
import DynamicIcon, {IconTypes} from "./DynamicIcon";
import Divider from "@mui/material/Divider";
import * as React from "react";
import {ReactNode} from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface IPaperConfig {
    p?: number;
    display?: string;
    flexDirection?: string;
    minHeight?: number;
}

interface ICardProps {
    icon?: IconTypes;
    titleDashboard?: string;
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    children: ReactNode;
    headerContent?: ReactNode;
    paperConfig?: IPaperConfig;
    marginTop?: string;
    lineDividerHeader?: boolean;
}


const paperConfigDefault = {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 350
}

const Card: React.FC<ICardProps> = ({
                                        icon = undefined,
                                        titleDashboard,
                                        xs = 12,
                                        md = 12,
                                        lg = 12,
                                        children,
                                        headerContent = undefined,
                                        paperConfig = paperConfigDefault,
                                        marginTop = '20px',
                                        lineDividerHeader = true
                                    }) => {

    return (<Grid item xs={xs} md={md} lg={lg}>
        <Paper sx={{
            p: paperConfig?.p ?? paperConfigDefault.p,
            display: paperConfig?.display ?? paperConfigDefault.display,
            flexDirection: paperConfig?.flexDirection ?? paperConfigDefault.flexDirection,
            minHeight: paperConfig?.minHeight ?? paperConfigDefault.minHeight
        }}>
            <Grid container>
                {
                    headerContent ?
                        headerContent
                        :
                        (<Grid item xs={12} md={12}>
                            <Typography variant="h6"
                                        sx={{color: '#1c2e4a', display: 'flex', alignItems: 'center'}}
                                        gutterBottom>
                                {icon && <DynamicIcon iconName={icon} color='#1c2e4a'/>} {titleDashboard}
                            </Typography>
                            {lineDividerHeader && <Divider/>}
                        </Grid>)
                }
                < Grid item xs={12}>
                    <div style={{marginTop: marginTop}}>{children}</div>
                </Grid>
            </Grid>
        </Paper>
    </Grid>);
}

export default Card;